export const handleLinkButtonClick = (
	link: string,
	event: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => {
	switch (event.button) {
		case 0:
			window.open(link, "_self", "noreferrer");
			break;
		case 1:
			event.preventDefault();
			window.open(link, "_blank", "noreferrer");
			break;
		default:
			return;
	}
};
